module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.classes]
  }, [_c('header', {
    staticClass: "main-header"
  }, [_c('nav', {
    staticClass: "navbar navbar-static-top navbar2",
    attrs: {
      "role": "navigation"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-center col-md-10 col-md-offset-2",
    staticStyle: {
      "margin-top": "-60px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "text-left col-md-8 col-md-offset-2"
  }, [_c('ul', {
    staticClass: "indexSteps"
  }, [_c('li', {
    staticClass: "indexStepLi"
  }, [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].indexProduct))]), _vm._v(" "), _c('li', {
    staticClass: "indexStepLi"
  }, [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].indexNews))]), _vm._v(" "), _c('li', {
    staticClass: "indexStepLi"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_c('a', {
    attrs: {
      "data-toggle": "dropdown",
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].indexResource))]), _vm._v(" "), _c('ul', {
    staticClass: "resourceSteps dropdown-menu w100",
    attrs: {
      "role": "menu",
      "aria-labelledby": "dLabel"
    }
  }, [_c('li', {
    staticClass: "resourceStepLi"
  }, [_vm._v("\n                                            " + _vm._s(_vm.$i18n.messages[_vm.$i18n.locale].indexDoc) + "\n                                        ")])])])]), _vm._v(" "), _c('li', {
    staticClass: "indexStepLi"
  }, [_c('a', {
    attrs: {
      "href": _vm.forumUrl,
      "target": "_new"
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$i18n.messages[_vm.$i18n.locale].indexForum) + "\n                                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right col-md-2",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav",
    staticStyle: {
      "float": "right"
    }
  }, [_c('li', {
    staticClass: "dropdown messages-menu"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    staticStyle: {
      "width": "70px",
      "min-width": "70px"
    }
  }, [_c('li', [_c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.$_admin_dash_change_lang('zh-TW')
      }
    }
  }, [_c('h4', {
    staticStyle: {
      "margin": "0 0 0 0"
    }
  }, [_vm._v("\n                                                        tw\n                                                        "), (_vm.$root.$i18n.locale === 'zh-TW') ? _c('i', {
    staticClass: "fa fa-check label-success"
  }) : _vm._e()])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.$_admin_dash_change_lang('en')
      }
    }
  }, [_c('h4', {
    staticStyle: {
      "margin": "0 0 0 0"
    }
  }, [_vm._v("\n                                                        en\n                                                        "), (_vm.$root.$i18n.locale === 'en') ? _c('i', {
    staticClass: "fa fa-check label-success"
  }) : _vm._e()])])])])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "900px",
      "margin-left": "0px"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "container register-table"
  }, [_c('div', {
    staticClass: "row vertical-8p"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "text-center col-md-10 col-sm-offset-1"
  }, [_c('h1', {}, [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].registerTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "text-center col-md-10 col-sm-offset-1"
  }, [_c('ul', {
    staticClass: "steps"
  }, [_c('li', {}, [_c('span', [_vm._v("1")]), _vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].registerFillInfo))]), _c('li', {
    staticClass: "current"
  }, [_c('span', [_vm._v("2")]), _vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].registerComplete))]), _c('li', {}, [_c('span', [_vm._v("3")]), _vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].registerFinish))])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-center col-md-8 col-sm-offset-2"
  }, [_c('form', {
    staticClass: "ui form regForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.checkCreds($event)
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "regEmail"
    }
  }, [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].email) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.email))])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'form-group has-error': _vm.$v.phone.$invalid
    }
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "regPhone"
    }
  }, [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].phone) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    ref: "regPhone",
    staticClass: "form-control",
    attrs: {
      "id": "regPhone",
      "name": "phone",
      "placeholder": "phone",
      "type": "text"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), (!_vm.$v.phone.required) ? _c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "regPhone"
    }
  }, [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].required))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'form-group has-error': _vm.$v.password.$invalid
    }
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "regPassword"
    }
  }, [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].password) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    ref: "regPassword",
    staticClass: "form-control",
    attrs: {
      "id": "regPassword",
      "name": "password",
      "placeholder": "password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), (!_vm.$v.password.required) ? _c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "regPassword"
    }
  }, [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].required))]) : _vm._e(), _vm._v(" "), (!_vm.$v.password.minLength) ? _c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "regPassword"
    }
  }, [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].minLength))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'form-group has-error': _vm.$v.confirmPassword.$invalid
    }
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "regConfirmPassword"
    }
  }, [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].confirmPassword) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    ref: "regConfirmPassword",
    staticClass: "form-control",
    attrs: {
      "id": "regConfirmPassword",
      "name": "confirmPassword",
      "placeholder": "confirm password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), (!_vm.$v.confirmPassword.sameAsPassword) ? _c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "regConfirmPassword"
    }
  }, [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].sameAsPassword))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "regType"
    }
  }, [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].type) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "regType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "private"
    }
  }, [_vm._v("private")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "company"
    }
  }, [_vm._v("company")])])])])]), _vm._v(" "), (_vm.type === 'company') ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "regCompanyName"
    }
  }, [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].companyName) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companyName),
      expression: "companyName"
    }],
    ref: "regCompanyName",
    staticClass: "form-control",
    attrs: {
      "id": "regCompanyName",
      "name": "companyName",
      "placeholder": "companyName",
      "type": "text"
    },
    domProps: {
      "value": (_vm.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyName = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "regWantMessage"
    }
  }, [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].wantMessage) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 text-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.wantMessage),
      expression: "wantMessage"
    }],
    ref: "regWantMessage",
    attrs: {
      "id": "regWantMessage",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.wantMessage) ? _vm._i(_vm.wantMessage, null) > -1 : (_vm.wantMessage)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.wantMessage,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.wantMessage = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.wantMessage = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.wantMessage = $$c
        }
      }
    }
  })])])]), _vm._v(" "), _c('button', {
    class: 'btn btn-primary btn-lg margin-top-7px' + _vm.loading,
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), (_vm.response) ? _c('div', {
    staticClass: "text-red"
  }, [_c('p', [_vm._v(_vm._s(_vm.response))])]) : _vm._e()])])])])]), _vm._v(" "), _c('footer', {
    staticClass: "main-footer",
    staticStyle: {
      "margin-left": "0px"
    }
  }, [_c('strong', [_vm._v("Copyright © " + _vm._s(_vm.year) + "\n            "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("NUWA Robotics")]), _vm._v(".")]), _vm._v(" All rights reserved.\n    ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive center-block logo",
    staticStyle: {
      "width": "300px",
      "height": "42px",
      "margin-top": "20px",
      "background-color": "#3c8dbc"
    },
    attrs: {
      "src": "/static/img/back_home_img.png",
      "alt": "Logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-language fa-lg"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-093a419d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserRegisterFillInfo.vue
// module id = 1461
// module chunks = 1